(() => {
  if (customElements.get('countdown-clock')) {
    return;
  }

  class CountdownClock extends HTMLElement {
    constructor() {
      super();

      this.date = this.dataset.date;
      this.clock = this.querySelector('.js-clock-preview');
      this.ends = this.querySelectorAll('.hero__countdown-end');
      this.images = this.querySelectorAll('.hero__countdown-image');
      this.content = this.querySelector('.hero__countdown-content');

      this.initCountdown();
    }

    initCountdown() {
      var targetTime = new Date(this.date).getTime();

      const that = this;
      const clock = this.clock;

      let currentTime = new Date().getTime();
      let timeDifference = targetTime - currentTime;

      if (timeDifference <= 0) {
        this.countdownClear();
      }

      // Update the countdown every second
      var countdownInterval = setInterval(function () {
        currentTime = new Date().getTime();
        timeDifference = targetTime - currentTime;

        // Calculate remaining days, hours, minutes, and seconds
        var days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
        var hours = Math.floor((timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        var minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);

        // Display the countdown
        clock.innerHTML = `<span><strong>${days}</strong> <small>days</small></span><span><strong>${hours}</strong> <small>hours</small></span><span><strong>${minutes}</strong> <small>minutes</small></span><span><strong>${seconds}</strong> <small>seconds</small></span>`;

        // If the countdown is finished:
        if (timeDifference < 0) {
          clearInterval(countdownInterval);
          that.content.classList.add('hidden');

          that.images.forEach((image) => {
            image.classList.add('hidden');
          });

          that.ends.forEach((end) => {
            end.classList.remove('hidden');
          });
        }
      }, 1000);
    }

    countdownClear() {
      this.content.classList.add('hidden');

      this.images.forEach((image) => {
        image.classList.add('hidden');
      });

      this.ends.forEach((end) => {
        end.classList.remove('hidden');
      });
    }
  }

  customElements.define('countdown-clock', CountdownClock);
})();
